<template>
  <section class="p-2">
    <v-card>
      <v-card>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Partner Routee</div>
          <div>
            <bread-crumb :bread-crumbs="['Partner Route']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
      </v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid">
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="2" lg="2" xs="12">
                <v-autocomplete
                  class=""
                  dense
                  outlined
                  placeholder="Country"
                  v-model="selectedItems.country"
                  :items="country_options"
                  item-text="txt"
                  item-value="val"
                  :clearable="isFieldClearable('country')"
                  @input="getfilterdataBycntry(selectedItems.country)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" lg="2" xs="12">
                <v-autocomplete
                  class=""
                  dense
                  outlined
                  placeholder="Payment method"
                  v-model="selectedItems.payment_mode"
                  :items="method_options"
                  :clearable="isFieldClearable('payment_mode')"
                  item-text="txt"
                  item-value="val"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" lg="2" xs="12">
                <v-autocomplete
                  class=""
                  dense
                  outlined
                  placeholder="Partner"
                  v-model="selectedItems.partner"
                  :items="partner_options"
                  :clearable="isFieldClearable('partner')"
                  item-text="txt"
                  item-value="val"
                ></v-autocomplete>
              </v-col>
              <div class="d-flex mt-1">
                <v-btn depressed 
                  small
                  class="text-capitalize"
                  color="primary"
                  outlined
                  @click="getAllPartnerRoutes()"
                  >Get Results</v-btn
                >
                <v-btn depressed 
                  small
                  class="ms-3 me-3 text-capitalize"
                  color="primary"
                  @click="openFormDialog()"
                  ><v-icon small>mdi-content-save-plus-outline</v-icon>Add</v-btn
                >
                <!-- <v-btn depressed  @click="downloadExcelsheet" color="primary" small
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn> -->
              </div>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>

      <v-card-text>
          <v-row class="ms-1 me-1 mt-2">
            <div class="d-flex">
              <v-btn depressed  @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            </div>
          </v-row>
        <!-- <v-row class="mb-5">
          <v-col cols="12" md="4" lg="4" xs="12"></v-col>
          <v-col cols="12" md="4" lg="3" xs="12"></v-col>
          <v-col cols="12" md="4" lg="5" xs="12">
            <v-text-field
              v-model="search"
              single-line
              label="Type here to search the table data."
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row> -->
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :search="search"
          :items="routeData"
          dense
          class="mt-6"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="(dialogDelete = true), (deleteId = item.id)"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
          <template v-slot:item.is_batch_push="{ item }">
            {{ item.is_batch_push === true ? "Yes" : "No" }}
            <!-- <v-switch v-model="item.is_batch_push" height="0px" dense color="success"></v-switch> -->
          </template>
          <template v-slot:item.payment_mode_data="{ item }">
            {{ item.payment_mode_data ? item.payment_mode_data.value : null }}
          </template>
          <template v-slot:item.country_data="{ item }">
            {{ item.country_data ? item.country_data.name : null }}
          </template>
          <template v-slot:item.currency_data="{ item }">
            {{
              item.currency_data
                ? `${item.currency_data.currency_name} (${item.currency_data.currency_code})`
                : null
            }}
          </template>
          <template v-slot:item.is_exrate_by_partner="{ item }">
            {{ item.is_exrate_by_partner === true ? "Yes" : "No" }}
            <!-- <v-switch v-model="item.is_exrate_by_partner" height="0px" dense color="success"></v-switch> -->
          </template>
          <template v-slot:item.is_active="{ item }">
            <v-switch
              v-model="item.is_active"
              height="0px"
              dense
              color="success"
              @change="isactiveupdate(item)"
            ></v-switch>
          </template>
        </v-data-table>
        <!-- add api partner -->
        <v-dialog persistent v-model="dialog" width="400">
          <v-card>
            <v-form ref="Addform" v-model="valid">
              <v-toolbar color="secondary" dark flat dense>
                <span>{{ formtitle }}</span>
                <v-spacer></v-spacer>
                <v-btn depressed  icon  @click="closeDialog()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Country
                    </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      :rules="countryRules"
                      placeholder="Country"
                      item-text="txt"
                      item-value="val"
                      v-model="partnerRoute.country"
                      @input="getformDropDetails(partnerRoute.country)"
                      :items="country_options"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Partner
                    </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Partner"
                      :rules="partnerRules"
                      v-model="partnerRoute.partner"
                      item-text="txt"
                      item-value="val"
                      :items="Add_partner_options"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Limit Currency
                    </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      :rules="currencyRules"
                      item-text="txt"
                      item-value="val"
                      :items="currencyOptions"
                      placeholder="Limit Currency"
                      v-model="partnerRoute.currency"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Payment Method
                    </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      :rules="paymentRules"
                      placeholder="Payment Method"
                      v-model="partnerRoute.payment_mode"
                      item-text="txt"
                      item-value="val"
                      :items="Add_payment_methods"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card-title class="d-flex justify-space-between p-0 m-0">
                      <div class="ps-2 headingFontsize">Is Batch Push</div>
                      <div>
                        <v-switch
                          v-model="partnerRoute.is_batch_push"
                          height="0px"
                          dense
                          color="success"
                        ></v-switch>
                      </div>
                    </v-card-title>
                    <v-card-title class="d-flex justify-space-between p-0 m-0">
                      <div class="ps-2 headingFontsize">
                        ExRate Call by Partner
                      </div>
                      <div>
                        <v-switch
                          height="0px"
                          dense
                          color="success"
                          v-model="partnerRoute.is_exrate_by_partner"
                        ></v-switch>
                      </div>
                    </v-card-title>
                    <v-card-title class="d-flex justify-space-between p-0 m-0">
                      <div class="ps-2 headingFontsize">Is Active</div>
                      <div>
                        <v-switch
                          height="0px"
                          dense
                          color="success"
                          v-model="partnerRoute.is_active"
                        ></v-switch>
                      </div>
                    </v-card-title>
                    <v-divider class="pa-0 ma-0 mb-2"></v-divider>
                  </v-col>

                  <div
                    class="col-md-12"
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 8px;
                    "
                  >
                    <v-btn depressed 
                      color="primary"
                      min-width="170px"
                      class="me-5 text-capitalize"
                      @click="onSubmitFor()"
                    >
                      {{ partnerRoute.id ? "Update" : "Add" }}
                    </v-btn>

                    <v-btn depressed 
                      color="primary"
                      class="text-capitalize"
                      outlined
                      min-width="170px"
                      @click="closeDialog()"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>
                  </div>
                </v-row>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- delete dialog -->
        <v-dialog persistent v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed  small color="primary" outlined @click="deleteItemConfirm">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn depressed 
                small
                color="primary"
                outlined
                @click="(dialogDelete = false), (deleteId = null)"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import { partnerRoute } from "@/utils/validation.js";

export default {
  name: "Partner Route",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  data: () => {
    return {
      ...partnerRoute,
      dialog: false,
      loader: false,
      valid: true,
      dialogDelete: false,
      editedIndex: -1,
      selectedCountry: "",
      country_options: [],
      method_options: [],
      Add_payment_methods: [],
      partner_options: [],
      Add_partner_options: [],
      currencyOptions: [],
      deleteId: null,
      search: "",
      partnerRoute: {
        id:null,
        partner: "",
        country: "",
        currency: "",
        payment_mode: "",
        is_exrate_by_partner: false,
        exrate: 0,
        is_batch_push: false,
        is_active: false,
      },
      selectedItems: {
        country: "",
        payment_mode: "",
        partner: "",
      },

      headers: [
        { text: "Partner", value: "partner" },
        { text: "Country", value: "country_data" },
        { text: "Limit Currency", value: "currency_data" },
        { text: "Payment method", value: "payment_mode_data" },
        { text: "is Batch Push", value: "is_batch_push" },
        { text: "ExRate Call by Partner", value: "is_exrate_by_partner" },
        { text: "is Active", value: "is_active" },
        { text: "Actions", value: "actions" },
      ],
      routeData: [],
    };
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  mounted() {
    this.getBeneCountryList();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.routeData) {
        this.exportToExcel(this.headers, this.routeData, "partner Route");
      }
    },
    isFieldClearable(fieldName) {
      return (
        this.selectedItems[fieldName] !== "" &&
        this.selectedItems[fieldName] !== null
      );
    },
    getfilterdataBycntry(selected_country) {
      if (selected_country) {
        this.getPaymentMode(selected_country, true);
        this.getPartnerType(selected_country, true);
      }
    },
    getformDropDetails(selected_country) {
      if (selected_country) {
        this.getPaymentMode(selected_country, false);
        this.getPartnerType(selected_country, false);
        this.getcurrencyList(selected_country);
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    onSubmitFor() {
      if (this.partnerRoute.id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.save();
        // console.log('update')
      }
    },
    async getAllPartnerRoutes() {
      // const validate = this.$refs.form.validate();
      // if (validate) {
      this.loader = true;
      try {
        const response = await setupService.getAllPartnerRouteData(
          this.selectedItems.country ? this.selectedItems.country : "",
          this.selectedItems.payment_mode
            ? this.selectedItems.payment_mode
            : "",
          this.selectedItems.partner ? this.selectedItems.partner : ""
        );
        if (response.data.status_code === 200) {
          this.routeData = response.data.data[0].reverse();
          this.stoploader();
          // this.method_options = null;
          // this.partner_options = null;
        } else if (response.data.status_code === 401) {
          // this.returnNewToken();
          // this.getAllPartnerRoutes();
          this.routeData = [];
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
          this.routeData = [];
        }
        console.log("All routes", response);
        // this.$refs.form.reset();
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
        this.routeData = [];
      }
      // }
    },
    resetValidation() {
      if (this.$refs.Addform) {
        this.$refs.Addform.reset();
      }
    },
    openFormDialog() {
      this.dialog = true;
      this.editedIndex = -1,
      this.resetValidation();
      this.partnerRoute = {
        partner: "",
        country: "",
        currency: "",
        payment_mode: "",
        is_exrate_by_partner: false,
        exrate: 0,
        is_batch_push: false,
        is_active: false,
      };
    },
    editItem(item) {
      this.editedIndex = this.routeData.indexOf(item);
      this.dialog = true;
      this.partnerRoute.country = item.country_data
        ? item.country_data.iso_alpha3
        : null;
      this.getPaymentMode(this.partnerRoute.country, false);
      this.getPartnerType(this.partnerRoute.country, false);
      this.getcurrencyList(this.partnerRoute.country);
      this.partnerRoute.partner = item.partner
      this.partnerRoute.id = item.id
      this.partnerRoute.is_active = item.is_active
      this.partnerRoute.is_batch_push = item.is_batch_push
      this.partnerRoute.is_exrate_by_partner = item.is_exrate_by_partner
      this.partnerRoute.payment_mode = item.payment_mode_data
        ? item.payment_mode_data.value_code
        : null;
      this.partnerRoute.currency = item.currency_data
        ? item.currency_data.currency_code
        : null;
      console.log(this.partnerRoute);
      // this.$refs.form.resetValidation();
    },
    closeDialog() {
      this.dialog = false;
      this.method_options = [];
      this.partner_options = [];
      this.$refs.form.reset();
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        setTimeout(() => {
          this.loader = false;
        }, 400);
        const responseData = await setupService.deletePartnerrouting(
          this.deleteId
        );
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllPartnerRoutes();
          this.dialogDelete = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
      }

    },
    async save() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        try {
          const responseData = await setupService.AddPartnerRouteData(
            this.partnerRoute
          );
          if (responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getAllPartnerRoutes();
            this.dialog = false;
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.save();
          // }
           else {
            this.showAlertError(responseData.data.message);
            this.dialog = false;
          }
          console.log("respose data", responseData);
        } catch (e) {
          console.error(e);
          this.dialog = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async update() {
      console.log(this.partnerRoute);
      try {
        const responseData = await setupService.updatePartnerRouteData(
          this.partnerRoute.id,
          this.partnerRoute
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllPartnerRoutes();
          this.dialog = false;
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.update();
        // } 
        else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        console.error(e);
        this.dialog = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async getcurrencyList(selected_country) {
      try {
        const response = await setupService.getcurrencydropdown(
          selected_country
        );
        if (response.data.status_code === 200) {
          console.log("response", response);
          this.currencyOptions = response.data.data[0].map((i) => {
            return {
              txt: `${i.currency_name}(${i.currency_code})`,
              val: i.currency_code,
            };
          });
        } 
        // else if (response.data.status_code === 401) {
        //   this.currencyOptions = [];
        //   this.returnNewToken();
        //   this.getcurrencyList();
        // }
         else {
          this.currencyOptions = [];
        }

        console.log("countrys", response);
      } catch (e) {
        this.currencyOptions = [];
        console.error(e);
        this.CountryList = [];
      }
    },
    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getBeneCountryList();
        // }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getPartnerType(event, is_filter) {
      this.loader = true;
      try {
        const responseData = await setupService.getPartnerByCountry(event);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          is_filter
            ? (this.partner_options = responseData.data.data[0].map((i) => {
                return {
                  txt: i.partner_name,
                  val: i.partner_name,
                };
              }))
            : (this.Add_partner_options = responseData.data.data[0].map((i) => {
                return {
                  txt: i.partner_name,
                  val: i.partner_name,
                };
              }));
          if (!this.partnerRoute.id) {
            // this.partnerRoute.partner = this.partner_options[0];
          }

          console.log("payment", responseData);
        } else if (responseData.data.status_code === 401) {
          is_filter
            ? (this.partner_options = [])
            : (this.Add_partner_options = []);
          // this.returnNewToken();
          // this.getPartnerType();
        } else {
          is_filter
            ? (this.partner_options = [])
            : (this.Add_partner_options = []);
        }
        console.log("partner", responseData);
      } catch (e) {
        is_filter
          ? (this.partner_options = [])
          : (this.Add_partner_options = []);
        this.loader = false;
        console.error(e);
      }
    },
    async getPaymentMode(event, is_filter) {
      this.loader = true;
      try {
        const responseData = await setupService.getPaymentByCountry(event);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          console.log("method options", responseData.data.data);
          is_filter
            ? (this.method_options = responseData.data.data.map((i) => {
                return {
                  txt: i.payment_mode.value,
                  val: i.payment_mode.value_code,
                };
              }))
            : (this.Add_payment_methods = responseData.data.data.map((i) => {
                return {
                  txt: i.payment_mode.value,
                  val: i.payment_mode.value_code,
                };
              }));
          if (!this.partnerRoute.id) {
            // this.partnerRoute.payment_mode = this.method_options[0];
          }
        } else if (responseData.data.status_code === 401) {
          is_filter
            ? (this.method_options = [])
            : (this.Add_payment_methods = []);
          // this.returnNewToken();
          // this.getPaymentMode();
        } else {
          is_filter
            ? (this.method_options = [])
            : (this.Add_payment_methods = []);
        }
        console.log("getPaymentMode", responseData);
      } catch (e) {
        is_filter
          ? (this.method_options = [])
          : (this.Add_payment_methods = []);
        this.loader = false;
        console.error(e);
      }
    },
    async isactiveupdate(isactive) {
      console.log(isactive);
      this.loader = true;
      try {
        const responseData = await setupService.updatePartnerRouteStatus(
          isactive.id,
          isactive.is_active
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(`Update status: ${responseData.data.message}`);
          this.getAllPartnerRoutes();
          this.stoploader();
        } 
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.isactiveupdate(isactive);
        // } 
        else {
          this.stoploader();
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style>
.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
